// extracted by mini-css-extract-plugin
module.exports = {"fullscreenControl":"FullscreenControl_fullscreenControl__2Rv8C"};